import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function useGallery() {
  const [items, setItems] = useState(GALLERY_ITEMS);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length > 0) setItems(r.data);
      })
      .catch(() => {});
  }, []);

  return items;
}
